const state = {
	messageGroup: {
		// messageClass: 'danger',
		// message: 'Test'
		messageClass: '',
		message: '',
		timeoutEvent: null,
	}
}

const mutations = {
	'ADD_MESSAGE' (state, {message, messageClass}) {
		state.messageGroup = {
			messageClass: messageClass || 'warning',
			message: message || 'Oop.. an unknown error occurred'
		}
		if (state.timeoutEvent) {
			clearTimeout(state.timeoutEvent);
		}
		state.timeoutEvent = setTimeout(function() {
			state.messageGroup = {
				messageClass: '',
				message: ''
			}
		}, 5000);
	},
	'CLEAR_MESSAGE' (state) {
		state.messageGroup = {
			messageClass: '',
			message: ''
		}
	}
}

const actions = {
	// Don't need action for now
	addMessage({commit}, msg) {
		commit('ADD_MESSAGE', { message: msg, messageClass: 'warning'});
	},
	addSuccessMessage({commit}, msg) {
		commit('ADD_MESSAGE', { message: msg, messageClass: 'success'});
	},
	addErrorMessage({commit}, msg) {
		commit('ADD_MESSAGE', { message: msg, messageClass: 'danger'});
	},
	clearMessage({commit}) {
		commit('CLEAR_MESSAGE');
	}
}

const getters = {
	messages: (state) => {
		return state.messageGroup;
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}
